import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { AuthService } from 'app/_services/auth.service';

import { of, switchMap } from 'rxjs';

export const NoAuthGuard: CanActivateFn | CanActivateChildFn = (route, state) => {
  const router: Router = inject(Router);
  const _authService: AuthService = inject(AuthService);
  // Check the authentication status
  const res = of(_authService.check()).pipe(
    switchMap((authenticated) => {
      // If the user is authenticated, redirect to the app root via UrlTree
      if (authenticated) {
        return of(router.createUrlTree(['/']));
      }

      // Not authenticated: in production open external auth and block the route
      if (_authService.isProduction) {
        window.open(`https://${window.location.hostname}/auth/sign-in`, '_self');
        return of(false);
      }

      // In non-production: allow access to the sign-in route itself to avoid loops.
      // If the requested URL is already `/sign-in`, allow activation; otherwise return
      // a UrlTree to redirect to `/sign-in` (router will handle it synchronously).
      const targetIsSignIn = state && state.url === '/sign-in';
      if (targetIsSignIn) {
        return of(true);
      }

      return of(router.createUrlTree(['sign-in']));
    })
  );
  return res;
};
